import { z } from 'zod';

export const enrollmentProgressRawSchema = z.object({
  data: z
    .object({
      userPrograms: z.array(
        z.object({
          completion: z.number(),
          nodes: z.array(
            z.object({
              key: z.string(),
              completion: z.number(),
            })
          ),
          history: z
            .object({
              last_viewed: z.object({
                part: z
                  .object({
                    key: z.string(),
                  })
                  .nullable(),
                lesson: z
                  .object({
                    key: z.string(),
                  })
                  .nullable(),
                concept: z
                  .object({
                    key: z.string(),
                  })
                  .nullable(),
              }),
            })
            .nullable(),
        })
      ),
    })
    .nullable(),
});

export const enrollmentProgressSchema = enrollmentProgressRawSchema.transform(({ data }) => {
  const lastViewed = data?.userPrograms[0].history?.last_viewed;

  return {
    completion: data ? Math.floor(data.userPrograms[0].completion) : 0,
    nodes: data
      ? data.userPrograms[0].nodes.map(({ key, completion }) => ({
          key,
          completion: Math.floor(completion),
        }))
      : [],
    lastViewedPartProgressKey: lastViewed?.part?.key ?? null,
    lastViewedLessonProgressKey: lastViewed?.lesson?.key ?? null,
    lastViewedConceptProgressKey: lastViewed?.concept?.key ?? null,
  };
});

export type EnrollmentProgress = z.infer<typeof enrollmentProgressSchema>;
export type EnrollmentProgressRaw = z.infer<typeof enrollmentProgressRawSchema>;
export type EnrollmentProgressResponse = z.input<typeof enrollmentProgressSchema>;

export const fetchEnrollmentProgressQuery = `
  query FetchEnrollmentProgress($uid: String!, $key:String!) {
    userPrograms(input: {userID: $uid, programKey: $key}) {
      completion
      nodes {
        key
        completion
      }
      history {
        last_viewed {
          part {
            key
          }
          lesson {
            key
          }
          concept {
            key
          }
        }
      }
    }
  }
`;
